<template>
  <div class="editor-header-buttons-group">
    <div class="small-buttons-group">
      <a
        v-if="isShowHelpCenter && !isEnableAddinPowerpoint"
        class="tab-trigger-btn text-link"
      >
        <EditorHeaderHelpCenter />
      </a>
    </div>

    <div v-if="canUseSpellchecker" class="presentation-quality-control__wrapper">
      <div class="presentation-quality-control__divider"></div>
      <PresentationQualityControl />
    </div>

    <div class="preview-present-buttons-group" v-if="!isEnableAddinPowerpoint">
      <PreviewButton class="-mt-1 block lg:ml-2" />
      <span class="-mt-1 sm:flex items-center">
        <aha-button
          class="aha-button-present"
          :disabled="isNewPresentation"
          v-tooltip="hotkeyTooltip"
          @mouseup.stop
        >
          <span
            class="flex items-center
                justify-center pl-2.5 pr-1.5 py-1.5"
            @click="onClickPresentButton"
          >
            <span class="w-5 h-5">
              <aha-icon
                name="play"
                viewBox="0 0 24 24"
                width="15"
                height="15"
                v-if="!waitPresenting"
              />
              <aha-spinner variant="white" v-else />
            </span>
            <span class="ml-1">Present</span>
          </span>

          <span
            class="h-6 border-r no-margin border-primary-100"
            @click="onClickPresentButton"
          />

          <!-- dropdown trigger -->
          <span
            class="block no-margin pl-1 pr-2.5 py-1.5"
            @click="$emit('togglePresentOptions')"
            @mouseup.stop
          >
            <span>
              <aha-icon
                name="arrow"
                width="14"
                height="14"
                viewBox="0 0 24 24"
              />
            </span>
          </span>
        </aha-button>
      </span>
    </div>
    <div class="button-divider"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories.js'
import PreviewButton from '@/components-v2/presentation-editor/middle/PreviewButton.vue'
import EditorHeaderHelpCenter from '@/components-v2/presentation-editor/editor-header/EditorHeaderHelpCenter.vue'
import PresentationMixpanelTracker from '@/utils/mixpanel/presentation.mixpanel-tracker'
import PresentationQualityControl from '@/components-v2/presentation-editor/editor-header/quality-control/PresentationQualityControl.vue'

export default {
  components: {
    PreviewButton,
    EditorHeaderHelpCenter,
    PresentationQualityControl,
  },
  props: {
    waitPresenting: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      tooltipHelp: {
        content: 'Help',
      },
    }
  },
  computed: {
    ...mapState({
      isNewPresentation: (state) => state.isNewPresentation,
      presentation: (state) => state.presentation,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      isReferPublicTemplate: (state) => state.isReferPublicTemplate,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      currentUser: (state) => state.currentUser,
    }),
    ...mapGetters('featureToggles', ['canUseSpellchecker']),

    hotkeyTooltip() {
      return {
        trigger: 'hover',
        content: `${this.$i18nPresenter.t('Present Now')} (Shift P)`,
      }
    },
    isShowSetting() {
      return this.presentation.id && this.presentation.showSetting
    },
    isShowResult() {
      return this.presentation.id && this.presentation.showExport
    },
    isShowHelpCenter() {
      return !this.isBackstage
    },
  },
  mounted() {
    this.tooltipHelp.content = this.$i18nPresenter.t('Help')
  },
  methods: {
    trackGAHelpCenter() {
      Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Header > Help')
    },

    trackStartPresenting() {
      const presentationTracker = new PresentationMixpanelTracker(this.presentation, this.$route.name, this.currentUser)
      presentationTracker.trackStartPresenting('Presentation Editor > Present Button', this.presentation.id)
    },

    onClickPresentButton() {
      if (this.waitPresenting) {
        return
      }
      this.$emit('startPresentingMode')
      this.trackStartPresenting()
      if (this.isReferPublicTemplate) {
        Utils.mixpanelTracking('Public template > Demo mode', 'Start presenting')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss-v2/variables.scss";

.editor-header-buttons-group {
  @apply flex items-center justify-end md:justify-between;
  .small-buttons-group {
    @apply flex items-center justify-between;
  }

  &.backstage-buttons {
    @apply justify-end;
  }

  .button-divider {
    @apply h-8 w-0.25 bg-secondary-20;
    margin-left: 7.5px;
    margin-right: 7.5px;
  }
}
.tab-trigger-btn {
  @apply relative top-1.5 items-center px-1.5 xl:px-2 pt-2 pb-6;
  // only apply transition to color. Prevent wierd background flicker when applying --active class
  transition-property: color;

  &--active {
    @apply z-20 bg-base-0 rounded-t-md text-primary-100;
  }
}
.preview-present-buttons-group {
  @apply flex gap-x-3;
}

.aha-button-present {
  @apply relative flex items-center justify-center p-0;
  span.no-margin {
    margin-left: 0;
  }
}
.icon-result {
  font-size: 16px;
  position: relative;
  top: 2px;
}
.presentation-quality-control__wrapper {
  @apply flex items-center mr-1;
  .presentation-quality-control__divider {
    @apply h-8 w-0.25 bg-secondary-20 mr-3;
    margin-left: 7.5px;
  }
}
</style>
